import { createApp, h } from 'vue';
import { createVfm } from 'vue-final-modal';
import App from './App.vue';

const declarations = document.querySelector('#declarations');

if (declarations) {
    const app = createApp({
        render() {
            return h(App, {
                insurer: declarations.dataset.insurer,
                logo: declarations.dataset.logo,
                pds: declarations.dataset.pds
            });
        }
    });

    const vfm = createVfm();
    app.use(vfm).mount(declarations);
}
